import { useState } from "react";
import CropPopup from "../LoanProduct/CropPopUp";
import { Button, Input, Popover, Select } from "antd";
import TextArea from "antd/es/input/TextArea";
import { useContext } from "react";
import { AasetupContext } from ".";
import PageLoader from "../../components/PageLoader";
import { useEffect } from "react";
import { IMAGE_BASE_URL } from "../../helpers/constants";
import { Controller, FormProvider, useForm } from "react-hook-form";
import axios from "../../axios/axios";
import { toast } from "react-toastify";
import { base64ToFile } from "../../common/Constants";
import { useLocation } from "react-router-dom";
async function dataURItoBlob(url) {
  return await (await fetch(url)).blob();
}
const AAFEdit = () => {
  const location = useLocation();
  const pagePermissions = location.state;
  const { setEditMode, isLoading, AAfData, authData, refetch, GetAAFSetupData } =
    useContext(AasetupContext);
  const [showCrop, setShowCrop] = useState(false);
  const [croppedImage, setCroppedImage] = useState(false);
  const [image, setImage] = useState(null);
  const methods = useForm({
    defaultValues: {
      logo: "",
      s_no: "",
      company_name: "",
      uen_no: "",
      country_code: "",
      contact_no: "",
      address: "",
      terms: "",
    },
  });
  const {
    handleSubmit,
    control,
    formState: { errors },
    setValue,
  } = methods;
  const onImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      setShowCrop(true);
      setImage(URL.createObjectURL(event.target.files[0]));
    }
  };

  const OnLedgerUpload = async (img) => {
    const formData = new FormData();
    const file = base64ToFile(img, "AAF-logo.png");
    formData.append("file[]", file);
    formData.append("module", "flooring");
    try {
      const response = await axios
        .post("/flooring/document", formData)
        .then((resp) => {
          setValue("logo", resp.data?.data[0].path);
        });
    } catch (error) {
    }
  };

  const updateAasetup = async (aaData) => {
    const postData = {
      sno: aaData.s_no,
      logo: aaData.logo,
      company_name: aaData.company_name,
      uen_no: aaData.uen_no,
      country_code: aaData.country_code,
      phone_number: aaData.contact_no,
      address: aaData.address,
      terms: aaData.terms,
    };
    console.log("POSTDATA", postData);
    const aaResp = await axios.put("/approval/advice-flooring/update", postData, {
      headers: {
        Authorization: `Bearer ${authData?.token}`,
      },
    });
    const respCode = aaResp?.data?.resp_code;
    if (respCode === 200) {
      refetch();
      GetAAFSetupData();
      toast.success(aaResp?.data.message);
      setEditMode(false);
    }
  };
  const updateCroppedImage = (img) => {
    setCroppedImage(img);
    setValue("logo", img);
    OnLedgerUpload(img)
  };
  useEffect(() => {
    if (AAfData) {
      setValue("s_no", AAfData?.sno);
      setValue("logo", AAfData?.logo);
      setValue("company_name", AAfData?.company_name);
      setValue("uen_no", AAfData?.uen_no);
      setValue("country_code", AAfData?.country_code);
      setValue("contact_no", AAfData?.phone_number);
      setValue("address", AAfData?.address);
      setValue("terms", AAfData?.terms);
    }
  }, [AAfData]);
  if (isLoading) {
    return <PageLoader />;
  }
  return (
    <>
      {showCrop ? (
        <CropPopup
          image={image}
          setActive={setShowCrop}
          setImage={updateCroppedImage}
        />
      ) : null}
      <form onSubmit={handleSubmit(updateAasetup)}>

        <h1 className="pt-[20px] pl-[30px] text-[20px] font-[700] mb-[20px] flex items-center gap-[13px]">
          <img
            src="/images/left-circle.svg"
            alt="arrow"
            className="cursor-pointer"
            onClick={() => setEditMode(false)}
          />{AAfData === null ? "Create AAF Deatails" : "Edit AAF Details"}

        </h1>
        <div className="p-[12px_30px] flex items-center gap-[15px] justify-between border-y border-[#EAEAEA]">
          <h3 className="text-[14px] font-[600]">
            Approval Advice For Flooring (AAF) Details
          </h3>
        </div>
        <div className="aa_details p-[20px_30px]">
          <Controller
            name="logo"
            control={control}
            rules={{
              required: true,
            }}
            render={({ field }) => {
              return (
                <div
                  className={`inline-block w-[120px] h-[80px] rounded-[6px] border mb-[10px] overflow-hidden ${errors?.logo ? "border-[#ff4d4f]" : "border-[#DEDEDE]"
                    }`}
                >
                  <img
                    className="h-full w-full object-cover"
                    src={
                      croppedImage
                        ? croppedImage
                        : AAfData?.logo
                          ? `${IMAGE_BASE_URL}/${AAfData?.logo}`
                          : ""
                    }
                    alt="logo"
                  />
                </div>
              );
            }}
          />
          <div>
            <input
              type="file"
              className="hidden"
              id="logoImg"
              onChange={(event) => onImageChange(event)}
            />
            <Button className="flex h-[unset] gap-[10px] items-center border-[#0F59F9] text-[#0F59F9] font-[600] text-[13px] p-[0]">
              <label className="p-[7px_18px] cursor-pointer" htmlFor="logoImg">
                Change Logo
              </label>
            </Button>
          </div>
          <div className="max-w-[600px] mt-[30px]">
            <div className="frm_inp_box mb-[20px]">
              <label className="text-[#495159] text-[13px] font-[600] mb-[8px] flex items-center">
                S No.
                <Popover content={"coming soon!"}>
                  <img
                    src="/images/fi_info.svg"
                    alt="info"
                    className="inline-block ml-[8px] cursor-pointer"
                  />
                </Popover>
              </label>
              <div className="flex items-center gap-[20px]">
                <Controller
                  control={control}
                  name="s_no"
                  rules={{
                    required: true,
                  }}
                  render={({ field }) => {
                    return (
                      <Input
                        {...field}
                        status={errors?.s_no ? "error" : null}
                        className="h-[40px] border-[#C3D2E2!important]"
                      />
                    );
                  }}
                />
                <Input
                  className="h-[40px] border-[#C3D2E2!important] aacusInp"
                  value="xxxxx"
                  disabled
                />
              </div>
            </div>
            <div className="frm_inp_box mb-[20px]">
              <label className="text-[#495159] text-[13px] font-[600] mb-[8px] block">
                Name of Company
              </label>
              <Controller
                control={control}
                name="company_name"
                rules={{
                  required: true,
                }}
                render={({ field }) => {
                  return (
                    <Input
                      {...field}
                      status={errors?.company_name ? "error" : null}
                      className="h-[40px] border-[#C3D2E2!important]"
                    />
                  );
                }}
              />
            </div>
            <div className="flex items-center gap-[20px] flex-wrap">
              <div className="frm_inp_box mb-[20px] flex-[1]">
                <label className="text-[#495159] text-[13px] font-[600] mb-[8px] block">
                  UEN No.
                </label>
                <Controller
                  control={control}
                  name="uen_no"
                  rules={{
                    required: true,
                  }}
                  render={({ field }) => {
                    return (
                      <Input
                        {...field}
                        status={errors?.uen_no ? "error" : null}
                        className="h-[40px] border-[#C3D2E2!important]"
                      />
                    );
                  }}
                />
              </div>
              <div className="frm_inp_box mb-[20px]">
                <label className="text-[#495159] text-[13px] font-[600] mb-[8px] block">
                  Country Code
                </label>
                <Controller
                  control={control}
                  name="country_code"
                  rules={{
                    required: true,
                  }}
                  render={({ field }) => {
                    return (
                      <Select
                        {...field}
                        status={errors?.country_code ? "error" : null}
                        className="aacusSelect"
                        options={[
                          {
                            value: "+65",
                            label: "+65",
                          },
                          {
                            value: "+45",
                            label: "+45",
                          },
                          {
                            value: "+91",
                            label: "+91",
                          },
                        ]}
                        suffixIcon={<img src="/images/selecArr.svg" />}
                      />
                    );
                  }}
                />
              </div>
              <div className="frm_inp_box mb-[20px] flex-[1]">
                <label className="text-[#495159] text-[13px] font-[600] mb-[8px] block">
                  Enquires Contact No
                </label>
                <Controller
                  control={control}
                  name="contact_no"
                  rules={{
                    required: true,
                  }}
                  render={({ field }) => {
                    return (
                      <Input
                        {...field}
                        //type="number"
                        maxLength={10}
                        status={errors?.contact_no ? "error" : null}
                        className="h-[40px] border-[#C3D2E2!important]"
                        onChange={(e) => {
                          const { value: inputValue } = e.target;
                          const reg = /^-?\d*(\.\d*)?$/;
                          if (reg.test(inputValue) || inputValue === '' || inputValue === '-') {
                            setValue("contact_no", inputValue);
                          }
                        }}
                      />
                    );
                  }}
                />
              </div>
            </div>
            <div className="frm_inp_box mb-[20px]">
              <label className="text-[#495159] text-[13px] font-[600] mb-[8px] block">
                Address
              </label>
              <Controller
                control={control}
                name="address"
                rules={{
                  required: true,
                }}
                render={({ field }) => {
                  return (
                    <TextArea
                      {...field}
                      status={errors?.address ? "error" : null}
                      className="h-[60px!important] border-[#C3D2E2!important]"
                    />
                  );
                }}
              />
            </div>
            <div className="frm_inp_box mb-[20px]">
              <label className="text-[#495159] text-[13px] font-[600] mb-[8px] block">
                Terms and Conditions
              </label>
              <Controller
                control={control}
                name="terms"
                rules={{
                  required: true,
                }}
                render={({ field }) => {
                  return (
                    <TextArea
                      {...field}
                      status={errors?.terms ? "error" : null}
                      className="h-[400px!important] border-[#C3D2E2!important]"
                    />
                  );
                }}
              />
            </div>
          </div>
          {(pagePermissions?.create_permission == 1 || pagePermissions?.update_permission == 1) && (
            <div className="text-end">
              <Button
                type="primary"
                htmlType="submit"
                className="font-[600] h-[40px] bg-[#055FFB]"
              >
                Save and Preview
              </Button>
            </div>
          )}
        </div>
      </form>
    </>
  );
};

export default AAFEdit;
